import { render, staticRenderFns } from "./qs2-07.vue?vue&type=template&id=501d32f0&scoped=true&"
import script from "./qs2-07.vue?vue&type=script&lang=js&"
export * from "./qs2-07.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d32f0",
  null
  
)

export default component.exports